import moment from 'moment'
import { apiGet, apiPost, apiPut, apiPatch, apiDelete } from '../lib/api'

export const LOAD_ATTENDANCES_SUCCESS = 'LOAD_ATTENDANCES_SUCCESS'
export const LOAD_ATTENDANCE_SUCCESS = 'LOAD_ATTENDANCE_SUCCESS'

export const ADD_ATTENDANCE = 'ADD_ATTENDANCE'
export const ADD_ATTENDER = 'ADD_ATTENDER'
export const ATTENDANCE_SAVE = 'ATTENDANCE_SAVE'
export const UPDATE_ATTENDER = 'UPDATE_ATTENDER'
export const DELETE_ATTENDER = 'DELETE_ATTENDER'
export const CLEAR_ATTENDENCE = 'CLEAR_ATTENDENCE'
export const CLEAR_ATTENDENCES = 'CLEAR_ATTENDENCES'

/* HEADER */
export const ATTENDANCE_HEADER_LOAD_START = 'ATTENDANCE_HEADER_LOAD_START'
export const ATTENDANCE_HEADER_LOAD_ERROR = 'ATTENDANCE_HEADER_LOAD_ERROR'
export const ATTENDANCE_HEADER_LOAD_SUCCESS = 'ATTENDANCE_HEADER_LOAD_SUCCESS'

export const ATTENDANCE_HEADER_CREATE_START = 'ATTENDANCE_HEADER_CREATE_START'
export const ATTENDANCE_HEADER_CREATE_ERROR = 'ATTENDANCE_HEADER_CREATE_ERROR'
export const ATTENDANCE_HEADER_CREATE_SUCCESS = 'ATTENDANCE_HEADER_CREATE_SUCCESS'

export const ATTENDANCE_HEADER_UPDATE_START = 'ATTENDANCE_HEADER_UPDATE_START'
export const ATTENDANCE_HEADER_UPDATE_ERROR = 'ATTENDANCE_HEADER_UPDATE_ERROR'
export const ATTENDANCE_HEADER_UPDATE_SUCCESS = 'ATTENDANCE_HEADER_UPDATE_SUCCESS'

export const ATTENDANCE_HEADER_DELETE_START = 'ATTENDANCE_HEADER_DELETE_START'
export const ATTENDANCE_HEADER_DELETE_ERROR = 'ATTENDANCE_HEADER_DELETE_ERROR'
export const ATTENDANCE_HEADER_DELETE_SUCCESS = 'ATTENDANCE_HEADER_DELETE_SUCCESS'

export const ATTENDANCE_HEADER_STATE = 'ATTENDANCE_HEADER_STATE'
export const ATTENDANCE_HEADER_CLEAR = 'ATTENDANCE_HEADER_CLEAR'

/* PDF */
export const ATTENDANCE_PDF_REMOVE_START = 'ATTENDANCE_PDF_REMOVE_START'
export const ATTENDANCE_PDF_REMOVE_ERROR = 'ATTENDANCE_PDF_REMOVE_ERROR'
export const ATTENDANCE_PDF_REMOVE_SUCCESS = 'ATTENDANCE_PDF_REMOVE_SUCCESS'

export const ATTENDANCE_FEEDBACKS_PDF_REMOVE_START = 'ATTENDANCE_FEEDBACKS_PDF_REMOVE_START'
export const ATTENDANCE_FEEDBACKS_PDF_REMOVE_ERROR = 'ATTENDANCE_FEEDBACKS_PDF_REMOVE_ERROR'
export const ATTENDANCE_FEEDBACKS_PDF_REMOVE_SUCCESS = 'ATTENDANCE_FEEDBACKS_PDF_REMOVE_SUCCESS'

export const ATTENDANCE_PDF_NEW_START = 'ATTENDANCE_PDF_NEW_START'
export const ATTENDANCE_PDF_NEW_ERROR = 'ATTENDANCE_PDF_NEW_ERROR'
export const ATTENDANCE_PDF_NEW_SUCCESS = 'ATTENDANCE_PDF_NEW_SUCCESS'

export const ATTENDANCE_PDF_SAVE_START = 'ATTENDANCE_PDF_SAVE_START'
export const ATTENDANCE_PDF_SAVE_ERROR = 'ATTENDANCE_PDF_SAVE_ERROR'
export const ATTENDANCE_PDF_SAVE_SUCCESS = 'ATTENDANCE_PDF_SAVE_SUCCESS'

export const ATTENDANCE_FEEDBACKS_PDF_SAVE_START = 'ATTENDANCE_FEEDBACKS_PDF_SAVE_START'
export const ATTENDANCE_FEEDBACKS_PDF_SAVE_ERROR = 'ATTENDANCE_FEEDBACKS_PDF_SAVE_ERROR'
export const ATTENDANCE_FEEDBACKS_PDF_SAVE_SUCCESS = 'ATTENDANCE_FEEDBACKS_PDF_SAVE_SUCCESS'

export const ATTENDANCE_SAVE_SUCCESS = 'ATTENDANCE_SAVE_SUCCESS'
export const ATTENDANCE_SAVE_ERROR = 'ATTENDANCE_SAVE_ERROR'
export const ATTENDANCE_UPDATE_SUCCESS = 'ATTENDANCE_UPDATE_SUCCESS'
export const ATTENDANCE_UPDATE_ERROR = 'ATTENDANCE_UPDATE_ERROR'
export const ATTENDANCE_BEGIN_SUCCESS = 'ATTENDANCE_BEGIN_SUCCESS'
export const ATTENDANCE_BEGIN_ERROR = 'ATTENDANCE_BEGIN_ERROR'


export const addAttendance = (params) => ({
  type: ADD_ATTENDANCE,
  payload: {
    attendance: Object.assign({}, { date: moment().format() }, params),
  },
})

export const addAttender = (attender) => ({
  type: ADD_ATTENDER,
  payload: {
    attender,
  },
})

export const updateAttender = (index, attender) => ({
  type: UPDATE_ATTENDER,
  payload: {
    index,
    attender,
  },
})

export const deleteAttender = (index) => ({
  type: DELETE_ATTENDER,
  payload: {
    index,
  },
})

export const clearAttendance = () => ({
  type: CLEAR_ATTENDENCE,
})

export const clearAttendances = () => ({
  type: CLEAR_ATTENDENCES,
})

/* HEADER */
export const loadAttendanceHeader = (id) => ({ getState, fetch }) => ({
  type: 'ATTENDANCE_HEADER_LOAD',
  payload: apiGet({
    fetch,
    endpoint: `attendheader/${id}`,
    getState,
  }),
})

export const createAttendanceHeader = (body) => ({ getState, fetch }) => ({
  type: 'ATTENDANCE_HEADER_CREATE',
  payload: apiPost({
    fetch,
    endpoint: 'attendheader',
    getState,
    body,
  }),
})

export const updateAttendanceHeader = (body) => ({ getState, fetch }) => ({
  type: 'ATTENDANCE_HEADER_UPDATE',
  payload: apiPut({
    fetch,
    endpoint: `attendheader/${body._id}`,
    getState,
    body,
  }),
})

export const stateAttendanceHeader = (id, state) => ({ getState, fetch }) => ({
  type: 'ATTENDANCE_HEADER_STATE',
  payload: apiPatch({
    fetch,
    endpoint: `attendheader/${id}`,
    getState,
    state,
  }),
})

export const deleteAttendanceHeader = (id) => ({ getState, fetch }) => ({
  type: 'ATTENDANCE_HEADER_DELETE',
  payload: apiDelete({
    fetch,
    endpoint: `attendheader/${id}`,
    getState,
  }),
})

export const clearAttendanceHeader = () => ({
  type: 'ATTENDANCE_HEADER_CLEAR',
  payload: {},
})
/* --- */

/* PDF */
export const pdfAttendanceRemove = (id) => ({ getState, fetch }) => ({
  type: 'ATTENDANCE_PDF_REMOVE',
  payload: apiGet({
    fetch,
    endpoint: `attendances/${id}/pdf_no`,
    getState,
  }),
})

export const feedbacksPdfAttendanceRemove = (id) => ({ getState, fetch }) => ({
  type: 'ATTENDANCE_FEEDBACKS_PDF_REMOVE',
  payload: apiGet({
    fetch,
    endpoint: `attendances/${id}/feedbacks_pdf_no`,
    getState,
  }),
})

export const pdfAttendanceNew = (id) => ({ getState, fetch }) => ({
  type: 'ATTENDANCE_PDF_NEW',
  payload: apiGet({
    fetch,
    endpoint: `attendances/${id}/pdf_new`,
    getState,
  }),
})

export const pdfAttendanceSave = (body) => ({ getState, fetch }) => ({
  type: 'ATTENDANCE_PDF_SAVE',
  payload: apiPost({
    fetch,
    endpoint: `attendances/${body._id}/pdf_save`,
    getState,
    body,
  }),
})

export const feedbacksPdfAttendanceSave = (body) => ({ getState, fetch }) => ({
  type: 'ATTENDANCE_FEEDBACKS_PDF_SAVE',
  payload: apiPost({
    fetch,
    endpoint: `attendances/${body._id}/feedbacks_pdf_save`,
    getState,
    body,
  }),
})
/* --- */

export const createAttendance = (body) => ({ getState, fetch }) => ({
  type: 'ATTENDANCE_SAVE',
  payload: apiPost({
    fetch,
    endpoint: 'attendances',
    getState,
    body,
  }),
})

export const updateAttendance = (id, body) => ({ getState, fetch }) => ({
  type: 'ATTENDANCE_UPDATE',
  payload: apiPatch({
    fetch,
    endpoint: `attendances/${id}`,
    getState,
    body,
  }),
})

export const loadAttendances = (query) => ({ getState, fetch }) => ({
  type: 'LOAD_ATTENDANCES',
  payload: apiGet({
    fetch,
    endpoint: 'attendances',
    getState,
    query,
  }),
})

export const loadAttendance = (id) => ({ getState, fetch }) => ({
  type: 'LOAD_ATTENDANCE',
  payload: apiGet({
    fetch,
    endpoint: `attendances/${id}`,
    getState,
  }),
})

export const getAttendancesCSV = (query) => ({ getState, fetch }) => ({
  type: 'DOWNLOAD_ATTENDANCES_CSV',
  payload: apiGet({
    fetch,
    endpoint: 'attendances/csv',
    getState,
    query,
  }),
})



// WEBPACK FOOTER //
// ./src/common/attendances/actions.js